/**
 * BrandLoading 尺寸配置
 *
 * 定义 5 级尺寸预设，统一品牌 Loading 的视觉规范
 */

export type BrandLoadingSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface SizeConfig {
  /** Logo 高度 (px) */
  height: number;
  /** Logo 宽度 (px)，保持比例 */
  width: number;
  /** 流光动画持续时间 (s) */
  shimmerDuration: number;
}

/**
 * 尺寸映射表
 *
 * | Size | 高度 | 使用场景 |
 * |------|------|---------|
 * | xs   | 16px | 按钮内 loading、表格行 |
 * | sm   | 24px | Antd Spin 默认 indicator |
 * | md   | 40px | 卡片、区块 loading |
 * | lg   | 64px | 页面级 loading |
 * | xl   | 96px | 全屏/路由切换 loading |
 */
export const SIZE_CONFIG: Record<BrandLoadingSize, SizeConfig> = {
  xs: {
    height: 16,
    width: 16,
    shimmerDuration: 1.2,
  },
  sm: {
    height: 24,
    width: 24,
    shimmerDuration: 1.3,
  },
  md: {
    height: 40,
    width: 40,
    shimmerDuration: 1.4,
  },
  lg: {
    height: 64,
    width: 64,
    shimmerDuration: 1.5,
  },
  xl: {
    height: 96,
    width: 96,
    shimmerDuration: 1.6,
  },
};

/**
 * 获取尺寸配置
 */
export const getSizeConfig = (size: BrandLoadingSize): SizeConfig => {
  return SIZE_CONFIG[size] || SIZE_CONFIG.md;
};
